import React from 'react';
import styled, { css } from 'styled-components';

const highlightSkeleton = css`
    strong {
        padding: 1px;
        border-radius: 3px;
        font-weight: normal;
        background-color: ${({ theme }) => theme.blue['100']};
    }
`;

const HighlightWrapper = styled.div`
    ${({ isRequiringHighlight }) => isRequiringHighlight && highlightSkeleton};
`;

const TextHighlighter = ({ entireString, stringToHighlight, title }) => {
    // Convert entireString to string if it's an array
    const stringToProcess = Array.isArray(entireString) ? entireString.join(' / ') : entireString;
    const isNeedOfHighlight = stringToHighlight?.length;
    const invalidChars = /[°"§\[\]\\?´`'<>|]+/g;
    const decomposeAndRebuild = () => {
        const validStringToHighlight = stringToHighlight?.replace(invalidChars, '');
        const decomposed = stringToProcess?.split(new RegExp(`(${validStringToHighlight})`, 'gi'));
        return decomposed?.map((part, i) => (
            <span className="highlight_wrapper" key={i}>
                {validStringToHighlight?.length && part.toLowerCase() === validStringToHighlight?.toLowerCase() ? (
                    <strong data-testid={`TextHighlight-${part}`}>{part}</strong>
                ) : (
                    <span className="highlight_span">{part}</span>
                )}
            </span>
        ));
    };
    return (
        <HighlightWrapper title={title} isRequiringHighlight={stringToHighlight?.length}>
            {isNeedOfHighlight ? decomposeAndRebuild() : entireString}
        </HighlightWrapper>
    );
};

export default TextHighlighter;
